/**
 * Byte sizes, written the way the API writes them.
 *
 * The upload limits are shared constants (`UPLOAD_MAX_BYTES` and friends), and
 * both sides have to render them the same way: a client warning that says "over
 * the 50 MB limit" next to a server rejection that says "52428800 bytes" reads
 * as two different limits. So this mirrors the API's `formatSize` — same units,
 * same one-decimal rounding, same thresholds.
 */

const UNITS = ['bytes', 'KB', 'MB', 'GB'] as const;

/** `1536` → `1.5 KB`, `52428800` → `50 MB`. Never throws on odd input. */
export const formatBytes = (bytes: number): string => {
  if (!Number.isFinite(bytes) || bytes <= 0) {
    return '0 bytes';
  }

  let size = bytes;
  let unit = 0;

  while (size >= 1024 && unit < UNITS.length - 1) {
    size /= 1024;
    unit += 1;
  }

  const rounded = Math.round(size * 10) / 10;

  return `${String(rounded)} ${UNITS[unit] ?? 'bytes'}`;
};
